import { SvelteMap } from "svelte/reactivity";
import { reportUiFailure } from "./report-failure.js";

// People seated in a channel by name (fetch_channel_cybos' `humans`, no email), for THAT
// channel's mention pills and picker only. Reactive, so a row drawn early re-renders its pill.
export interface SeatedHuman {
  userId: string;
  name: string;
}

const NONE: readonly SeatedHuman[] = [];
const byChannel = new SvelteMap<string, readonly SeatedHuman[]>();

export function rememberChannelSeatedHumans(
  channelId: string,
  humans: readonly SeatedHuman[],
): void {
  byChannel.set(channelId, humans);
}

export function channelSeatedHumans(channelId: string | null | undefined): readonly SeatedHuman[] {
  return (channelId && byChannel.get(channelId)) || NONE;
}

// The seats read (workspace-crud's fetchChannelCybosWithIdentity), registered there: importing it
// here would cycle through the state barrel.
type SeatLoader = (channelId: string) => Promise<unknown>;
let seatLoader: SeatLoader | null = null; // null: nothing registered (tests, early boot)
const asked = new Set<string>();

export function setChannelSeatedHumansLoader(load: SeatLoader): void {
  seatLoader = load;
}

// A row outside a mounted composer (search, saved) that mentions someone the workspace roster
// does not hold: load THAT channel's seats once, so the pill renders there too. No retry.
export function loadChannelSeatedHumansOnce(channelId: string): void {
  if (!seatLoader || byChannel.has(channelId) || asked.has(channelId)) return;
  asked.add(channelId);
  seatLoader(channelId).catch((err: unknown) => {
    reportUiFailure("mentions.channel_seats", err, { channelId });
  });
}
